// Whether the personalization prompt is deferred out of product configuration
// and shown once, late, at checkout.
//
// Studios on the `prepay_personalization_prompted_before_checkout_only` policy
// prompt prepay customers a single time on the way to the cart
// (PreCartOffers / PreDashboardOffers route to /v3/personalization-offer).
// Every flow that would otherwise prompt DURING configuration has to suppress
// its own prompt for exactly those sessions — and the deferred prompt never
// runs postpay, so a postpay session must always be offered personalization
// during configuration.
//
// That makes this one rule with two halves: the flows that suppress the prompt
// and the flows that later show it. It was spelled out four times, the magic
// string included, with the reasoning recorded in only one of them. It lives
// here so the halves cannot drift apart — a policy change that reached the
// suppressors but not the presenters would silently drop the prompt entirely,
// and a required personalization then fails the checkout gate with nothing the
// customer can do about it.
//
// See docs/features/prepay-personalization-offer-type.md.
export const PREPAY_PERSONALIZATION_BEFORE_CHECKOUT_ONLY =
  'prepay_personalization_prompted_before_checkout_only';

// The two fields are mirrored on the shoot slice as `isPrepay` /
// `prepayPersonalizationOfferType` (reducer_shoot), and the nested
// `shoot.shoot.is_prepay` is the same payload field — callers reading either
// mirror can pass it here.
interface PersonalizationOfferShoot {
  isPrepay?: boolean | null;
  prepayPersonalizationOfferType?: string | null;
}

export const personalizationDeferredToCheckout = (
  shoot: PersonalizationOfferShoot | null | undefined,
): boolean =>
  Boolean(shoot?.isPrepay) &&
  shoot?.prepayPersonalizationOfferType ===
    PREPAY_PERSONALIZATION_BEFORE_CHECKOUT_ONLY;
